import React from 'react';
import { useState } from 'react';
import { Grid, Card, CardMedia, Typography } from '@mui/material';

const CardConvidados = ({ image, title, nome, cargo, descricao }) => {
  const [isHovered, setHovered] = useState(false);

  return (
    <Grid sx={{ marginTop: '20px', marginLeft: '20px' }} className='div-card-convidados'>
      <Card
        className={`card-convidados ${isHovered ? 'hovered' : ''}`}
        sx={{
          width: { xl: '330px', lg: '200px', xs: '250px' },
          height: { xl: '300px', lg: '230px', xs: '200px' },
          borderRadius: '12px',
          border: '2px solid #f5f5f5',
          position: 'relative',
          overflow: 'hidden',
          transition: 'height 0.8s',
          '&:hover': {
            height: { xl: '350px', lg: '250px' },
          },
        }}
        onMouseEnter={() => setHovered(true)}
        onMouseLeave={() => setHovered(false)}
      >
        <CardMedia sx={{ width: { xl: '330px', lg: '200px' }, height: { xl: '300px', lg: '230px' } }}>
          <img src={image} alt={title} className='img-autoridades' />
        </CardMedia>
        <Grid
          sx={{
            backgroundColor: '#0147A8',
            height: isHovered ? '100px' : '0',
            overflow: 'hidden',
            textAlign: 'center',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            position: 'absolute',
            bottom: 0,
            left: 0,
            width: '100%',
            transition: 'height 0.3s',
          }}
        >
          <Typography sx={{ color: '#fff', fontSize: { xl: '20px', lg: '15px' }, fontWeight: 'bold' }}>{nome}</Typography>
          <Typography sx={{ color: '#fff', fontSize: { xl: '16px', lg: '12px' } }}>{cargo}</Typography>
          <Typography sx={{ color: '#fff', fontSize: { xl: '16px', lg: '12px' } }}>{descricao}</Typography>
        </Grid>
      </Card>
    </Grid>

  );
};

export default CardConvidados;
